import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "room-navigator" }
const _hoisted_2 = { class: "room-navigator-content" }
const _hoisted_3 = { class: "nav-section dashboard" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "nav-section building" }
const _hoisted_6 = { class: "nav-section room" }
const _hoisted_7 = { class: "room-controls" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "nav-section filter ms-auto" }

import { computed, ref, watch } from "vue";
import { generateResourceIconClass } from "../../calendar/utils/resourceIconUtils";
import VueMultiselect from "vue-multiselect";


export default {
  __name: 'RoomNavigator',
  props: {
	currentRoomId: { type: Number, required: true },
	buildings: { type: Array, required: true },
	allRooms: { type: Array, required: true },
	roomsByBuilding: { type: Object, required: true },
	dashboardUrl: { type: String, required: true },
},
  emits: ["navigate-to-room"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Current selections
const selectedBuilding = ref(null);
const selectedRoom = ref(props.allRooms.find((room) => room.id === props.currentRoomId));

// Only show buildings where at least one room in viewable
const availableBuildings = computed(() =>
  props.buildings.filter((building) => building.rooms.length > 0)
);

// Select the current room
const currentRoom = computed(() =>
	props.allRooms.find((room) => room.id === props.currentRoomId)
);

// Set initial building based on current room
if (currentRoom.value) {
	const currentBuilding = props.buildings.find((building) =>
		building.rooms?.some((room) => room.id === props.currentRoomId)
	);
	if (currentBuilding) {
		selectedBuilding.value = currentBuilding;
	}
}

// Get rooms for currently selected building, sorted by doorLabel/name
const currentBuildingRooms = computed(() => {
	if (
		!selectedBuilding.value ||
		!props.roomsByBuilding[selectedBuilding.value.id]
	) {
		return [];
	}

	const rooms = props.roomsByBuilding[selectedBuilding.value.id].rooms || [];
	return [...rooms].sort((a, b) => {
		const aLabel = a.doorLabel || a.name || "";
		const bLabel = b.doorLabel || b.name || "";
		return aLabel.localeCompare(bLabel, "de", { numeric: true });
	});
});

// Find current room index for navigation
const currentRoomIndex = computed(() =>
	currentBuildingRooms.value.findIndex(
		(room) => room.id === selectedRoom.value.id
	)
);

// Navigation availability
const canNavigatePrevious = computed(() => currentRoomIndex.value > 0);
const canNavigateNext = computed(
	() =>
		currentRoomIndex.value >= 0 &&
		currentRoomIndex.value < currentBuildingRooms.value.length - 1
);

// Helper function to get room display label with lock if non-bookable
function getRoomDisplayLabel(room) {
	return room.doorLabel + (room.name ? " " + room.name : "");
}

// Helper to preserve URL parameters when navigating
function preserveUrlParams(roomId) {
	const currentParams = new URLSearchParams(window.location.search);
	const newUrl = `${window.location.pathname.split('/').slice(0, -1).join('/')}/${roomId}`;
	
	if (currentParams.toString()) {
		return `${newUrl}?${currentParams.toString()}`;
	}
	return newUrl;
}

// Event handlers
function onBuildingChange() {
	// When building changes, select the first room in that building
	if (currentBuildingRooms.value.length > 0) {
		selectedRoom.value = currentBuildingRooms.value[0];
		onRoomChange();
	}
}

function onRoomChange() {
	if (selectedRoom.value?.id !== props.currentRoomId) {
    window.location.href = preserveUrlParams(selectedRoom.value.id);
	}
}

function navigatePrevious() {
	if (canNavigatePrevious.value) {
		const prevRoom = currentBuildingRooms.value[currentRoomIndex.value - 1];
    window.location.href = preserveUrlParams(prevRoom.id);
	}
}

function navigateNext() {
	if (canNavigateNext.value) {
		const nextRoom = currentBuildingRooms.value[currentRoomIndex.value + 1];
		const newUrl = preserveUrlParams(nextRoom.id);
		window.location.href = newUrl;
	}
}

// Watch for external room changes
watch(
	() => props.currentRoomId,
	(newRoomId) => {
		selectedRoomId.value = newRoomId;

		// Update building selection if needed
		const newRoom = props.allRooms.find((room) => room.id === newRoomId);
		if (newRoom) {
			const newBuilding = props.buildings.find((building) =>
				building.rooms?.some((room) => room.id === newRoomId)
			);
			if (newBuilding) {
				selectedBuildingId.value = newBuilding.id;
			}
		}
	}
);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: __props.dashboardUrl,
          class: "btn btn-outline-primary btn-sm dashboard-btn",
          title: "Zurück zum Dashboard"
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fas fa-home" }, null, -1 /* CACHED */),
          _createElementVNode("span", { class: "dashboard-text" }, "Dashboard", -1 /* CACHED */)
        ]))], 8 /* PROPS */, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(VueMultiselect), {
          modelValue: selectedBuilding.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((selectedBuilding).value = $event)),
          searchable: false,
          "show-labels": false,
          "allow-empty": false,
          options: availableBuildings.value,
          "track-by": "id",
          label: "name",
          onSelect: onBuildingChange
        }, {
          singleLabel: _withCtx(({ option }) => [
            _createTextVNode(_toDisplayString(option.name), 1 /* TEXT */)
          ]),
          option: _withCtx(({ option }) => [
            _createTextVNode(_toDisplayString(option.short) + ": " + _toDisplayString(option.name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary btn-sm nav-arrow",
            disabled: !canNavigatePrevious.value,
            title: "Vorheriger Raum",
            onClick: navigatePrevious
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_8),
          _createVNode(_unref(VueMultiselect), {
            modelValue: selectedRoom.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((selectedRoom).value = $event)),
            searchable: false,
            "show-labels": false,
            options: currentBuildingRooms.value,
            "track-by": "id",
            label: "doorLabel",
            onSelect: onRoomChange
          }, {
            singleLabel: _withCtx(({ option }) => [
              _createElementVNode("i", {
                class: _normalizeClass(_unref(generateResourceIconClass)(option))
              }, null, 2 /* CLASS */),
              _createTextVNode(" " + _toDisplayString(getRoomDisplayLabel(option)), 1 /* TEXT */)
            ]),
            option: _withCtx(({ option }) => [
              _createElementVNode("i", {
                class: _normalizeClass(_unref(generateResourceIconClass)(option))
              }, null, 2 /* CLASS */),
              _createTextVNode(" " + _toDisplayString(getRoomDisplayLabel(option)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "options"]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary btn-sm nav-arrow",
            disabled: !canNavigateNext.value,
            title: "Nächster Raum",
            onClick: navigateNext
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

}